export default "__VITE_ASSET__BP4Uj_OZ__"